<template>
  <div>
    <h2 class="step-name">Cow Environment</h2>
		<div class="alert alert-success text-center">
			This step is optional.
		</div>
    <div class="step-section">
      <div class="clearfix" :style="{ width: 400 + widthForRow(getFieldValue('FARMS')) + 'px' }">

        <div v-for="farm in getFieldValue('FARMS')" class="farm-fields" :key="farm.id">
          <h3>{{ farm.farm_label }}</h3>

          <radio-input label="Do the cows calve on the milking platform?"
                       :field-name="`farm_${farm.id}-is_calving_cows_on_platform`"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Location of cows for calving?"
                       :field-name="`farm_${farm.id}-location_of_calving_cows`"
                       :addComment="true"
                       :choices="[
                                  {value: 'Grass', display: 'Grass'},
                                  {value: 'Pad', display: 'Pad'},
                                  {value: 'Other', display: 'Other'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Feed pad used during season?"
                       :field-name="`farm_${farm.id}-is_feed_pad_used_season`"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Herd flow to and from shed disrupted by road crossing, waiting for second herd etc."
                       :field-name="`farm_${farm.id}-is_herd_flow_disrupted`"
                       :addComment="true"
                       :choices="[
                                  {value: 'Yes', display: 'Yes'},
                                  {value: 'No', display: 'No'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>

          <radio-input label="Condition of gateways, underpasses and shed entry/exits?"
                       :field-name="`farm_${farm.id}-condition_of_environment`"
                       :addComment="true"
                       :choices="[
                                  {value: 'Excellent', display: 'Excellent'},
                                  {value: 'Satisfactory', display: 'Satisfactory'},
                                  {value: 'Poor', display: 'Poor'},
                                  ]"
                       :disabled="isReadOnly">
          </radio-input>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'CowEnvironment',
  mixins: [ baseComponent ],
};
</script>
